module.exports = __webpack_public_path__ + "img/csa_button_tactics_dojo.620021f4.png";